// PetCompass Shopify Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile menu ──
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileNav.classList.remove('is-open'); });
    });
  }

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-item').forEach(function (item) {
    item.querySelector('.faq-question').addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('is-open'); });
      if (!isOpen) item.classList.add('is-open');
    });
  });

  // ── Email capture form ──
  document.querySelectorAll('.email-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('.email-input');
      if (input && input.value) {
        alert('Thanks! We\'ll notify you at ' + input.value + ' when pre-orders open.');
        input.value = '';
      }
    });
  });

  // ── Pricing buttons ──
  document.querySelectorAll('[data-product-handle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var handle = btn.getAttribute('data-product-handle');
      if (handle) window.location.href = '/products/' + handle;
    });
  });

});
